import React, { useEffect, useMemo } from "react";
import { Modal } from "react-bootstrap";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { ModalProgressBar } from "../../../../../../_metronic/_partials/controls";
import * as actions from "../../../../../../app/actions/generalActions";
import { useObjectsUIContext } from "../ObjectsUIContext";
import { useFilterObjectsUIContext } from "../FilterObjectsUIContext";

export function ObjectRefreshDialog({ api, id, show, onHide, currentState, softDelete, getQueryFunctionName }) {
  const objectsUIContext = useObjectsUIContext();
  const filterUIContext = useFilterObjectsUIContext();
  const objectsUIProps = useMemo(() => {
    return {
      setIds: objectsUIContext.setIds,
      queryParams: filterUIContext.queryParams,
    };
  }, [objectsUIContext, filterUIContext]);

  const dispatch = useDispatch();
  const { isLoading } = useSelector(
    (state) => ({ isLoading: currentState.actionsLoading }),
    shallowEqual
  );

  useEffect(() => {
    if (!id) {
      onHide();
    }

  }, [id]);

  const { name, lastError, lastMsg } = currentState;

  useEffect(() => { }, [isLoading, dispatch]);
  const deleteObject = () => {
    var ids = []
    ids.push(id)
    dispatch(actions.updateObjectsStatus(api, name, ids, false)).then(() => {
      dispatch(actions.fetchObjects(api, name, objectsUIProps.queryParams, getQueryFunctionName));
      objectsUIProps.setIds([]);
      onHide();
    });
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      aria-labelledby="example-modal-sizes-title-lg"
    >
      {isLoading && <ModalProgressBar variant="query" />}
      <Modal.Header closeButton>
        <Modal.Title id="example-modal-sizes-title-lg">
          فعالسازی رکورد
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {!isLoading && (
          <span>آیا از فعالسازی اطمینان دارید؟</span>
        )}
        {isLoading && <span>در حال فعالسازی...</span>}
      </Modal.Body>
      <Modal.Footer>
        <div>
          <button
            type="button"
            onClick={onHide}
            className="btn btn-light btn-elevate"
          >
            انصراف
          </button>
          <> </>
          <button
            type="button"
            onClick={deleteObject}
            className="btn btn-primary btn-elevate"
          >
            فعالسازی
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
